import React, { useState } from "react";
import { TextInput, StyleSheet, View, Pressable } from "react-native";
import { EyeIcon, EyeSlashIcon, EnvelopeIcon, MagnifyingGlassIcon, InfoIcon } from "@phosphor-icons/react";
import CustomText from "../CustomText/CustomText";

function CustomTextInput({
  inputType = "text",
  value,
  onChangeText,
  placeholder,
  style = {},
  secureTextEntry = false,
  onToggleSecureEntry = undefined,
  error = undefined,
  helperText = undefined,
  ...props
}) {
  const [isActive, setIsActive] = useState(false);
  const isEmail = inputType === "email";
  const isSearch = inputType === "search";
  const hasSecureToggle = typeof onToggleSecureEntry === "function";
  const combinedStyles = [
    styles.input,
    (isEmail || isSearch) && styles.hasPrefixIcon,
    hasSecureToggle && styles.hasSuffixIcon,
    style,
    isActive && styles.activeInput,
    error != null && error !== "" && styles.errorInput,
    error != null && error !== "" && isActive && styles.errorInputActive,
  ];

  const handleToggleSecureEntry = () => {
    if (hasSecureToggle) {
      onToggleSecureEntry();
    }
  };

  return (
    <View style={styles.container}>
      <View style={styles.inputWrapper}>
        {isEmail && (
          <View style={styles.prefixIcon}>
            <EnvelopeIcon size={20} />
          </View>
        )}
        {isSearch && (
          <View style={styles.prefixIcon}>
            <MagnifyingGlassIcon size={20} />
          </View>
        )}
        <TextInput
          style={combinedStyles}
          value={value}
          onChangeText={onChangeText}
          placeholder={placeholder}
          placeholderTextColor="#A1A1A1"
          secureTextEntry={secureTextEntry}
          onFocus={() => {
            setIsActive(true);
          }}
          onBlur={() => {
            setIsActive(false);
          }}
          {...props}
        />
        {hasSecureToggle && (
          <Pressable
            onPress={handleToggleSecureEntry}
            style={styles.icon}
            accessibilityRole="button"
            accessibilityLabel={secureTextEntry ? "Show password" : "Hide password"}>
            {secureTextEntry ? <EyeIcon size={20} color="#6B7280" /> : <EyeSlashIcon size={20} color="#6B7280" />}
          </Pressable>
        )}
        {error != null && error !== "" && (
          <View style={styles.icon}>
            <InfoIcon size={16} color="#dc2626" weight="fill" />
          </View>
        )}
      </View>
      {helperText != null && helperText !== "" && (
        <CustomText style={styles.helperText} text={helperText} useTranslationText={false} />
      )}
      {error != null && error !== "" && <CustomText style={styles.errorText} text={error} useTranslationText={false} />}
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
  },
  input: {
    borderWidth: 1,
    borderColor: "#D1D5DB",
    color: "#1F2937",
    fontSize: 14,
    borderRadius: 8,
    width: "100%",
    padding: 10,
    outlineWidth: 2,
    outlineOffset: 2,
  },
  activeInput: {
    outlineColor: "#6788fe",
  },
  errorInputActive: {
    outlineColor: "#fee2e2",
    borderColor: "#ef4444",
  },
  errorInput: {
    borderColor: "#fca5a5",
  },
  inputWrapper: {
    position: "relative",
    flex: 1,
  },
  icon: {
    position: "absolute",
    right: 10,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  hasPrefixIcon: {
    paddingLeft: 35,
  },
  hasSuffixIcon: {
    paddingRight: 35,
  },
  prefixIcon: {
    position: "absolute",
    left: 10,
    top: 0,
    bottom: 0,
    justifyContent: "center",
    alignItems: "center",
  },
  errorText: {
    color: "#dc2626",
    fontSize: 12,
  },
  helperText: {
    fontSize: 12,
    color: "#667085",
  },
});

export default CustomTextInput;
